var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.014,
    height: 10.941,
    viewBox: "0 0 31.014 10.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(17.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M12.941,46.305,8.192,41.556a.722.722,0,0,0-1.018,0l-.431.431a.714.714,0,0,0-.21.509.729.729,0,0,0,.21.515l2.771,2.777H-17.152a.7.7,0,0,0-.71.708v.61a.729.729,0,0,0,.71.739h26.7l-2.8,2.792a.713.713,0,0,0,0,1.011l.431.43a.722.722,0,0,0,1.018,0l4.749-4.749a.726.726,0,0,0,0-1.022Z",
    transform: "translate(0 -41.346)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/white-arrow.0d7405c56b461db9adb18202566aba3e.svg";
export { ForwardRef as ReactComponent };